import { render, staticRenderFns } from "./MyPassword.vue?vue&type=template&id=0900e5d2&scoped=true"
import script from "./MyPassword.vue?vue&type=script&lang=js"
export * from "./MyPassword.vue?vue&type=script&lang=js"
import style0 from "./MyPassword.vue?vue&type=style&index=0&id=0900e5d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0900e5d2",
  null
  
)

export default component.exports